import React from 'react';
import styled from "styled-components"
import LineDivider from '../LineDivider'

let dummyResponse = {
    responseJson: {
      "TransactionDetails": {
        "workflow": "TransactionDetails",
        "transactionStatus": "success",
        response: [
          {
            amount: "49",
            narrative: "REV BILLS2PAY-AIRTEL PRE*",
            Date: "19/01/2021"
          },
          {
            amount: "49",
            narrative: "REV BILLS2PAY-AIRTEL PRE*",
            Date: "19/01/2021"
          },
          {
            amount: "433",
            narrative: "REV BILLS2PAY-INDIA POWE*",
            Date: "09/11/2020"
          },
          {
            amount: "149",
            narrative: "REV BILLS2PAY-AIRTEL PRE*",
            Date: "02/11/2020"
          }
        ]
      }
    }
  }

//   creditCardStatementsDetails  --
const CreditCardStatement = ({creditCardStatementDetails, flag}) => {
    const showCreditCardStatement = ()=>{
        return [creditCardStatementDetails].map((item,i)=>{
            return(
                <StatementDetail key={i}>
                    <div>
                        Statement Date:
                    </div>
                    <div className="value">
                        {item.lastStatementDate}
                    </div>
                    <LineDivider />
                    <div>
                        Payment Due Date:
                    </div>
                    <div className="value">
                        {item.paymentDueDate}
                    </div>
                    <LineDivider />
                    <div>
                        Total Amount Due:
                    </div>
                    <div className="value"
                    >
                       Rs. {item.totalAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Minimum Amount Due:
                    </div>
                    <div className="value">
                        Rs. {item.minimumAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Amount:
                    </div>
                    <div className="value">
                        Rs. {item.lastPaymentAmount}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Date:
                    </div>
                    <div className={`value`}>
                        {item.lastPaymentDate}
                    </div>
                    <LineDivider />
                    <div>
                        Available Credit Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCreditLimit}
                    </div>
                    <LineDivider />
                    <div>
                        Available Cash Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCashLimit}
                    </div>
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardStatement()}
        </React.Fragment>
    );
};

//StatementDetailsForLastPayment--
const StatementDetailForLastPayment = ({statementDetailsForLastPayment, flag}) => {
    const showCreditCardStatement = ()=>{
        return [statementDetailsForLastPayment].map((item,i)=>{
            return(
                <StatementDetail key={i}>
               <div>
                        Statement Date:
                    </div>
                    <div className="value">
                        {item.lastStatementDate}
                    </div>
                    <LineDivider />
                    <div>
                        Payment Due Date:
                    </div>
                    <div className="value">
                        {item.paymentDueDate}
                    </div>
                    <LineDivider />
                    <div>
                        Total Amount Due:
                    </div>
                    <div className="value"
                    >
                       Rs. {item.totalAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Minimum Amount Due:
                    </div>
                    <div className="value">
                        Rs. {item.minimumAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Amount:
                    </div>
                    <div className="value">
                        Rs. {item.lastPaymentAmount}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Date:
                    </div>
                    <div className={`value`}>
                        {item.lastPaymentDate}
                    </div>
                    <LineDivider />
                    <div>
                        Available Credit Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCreditLimit}
                    </div>
                    <LineDivider />
                    <div>
                        Available Cash Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCashLimit}
                    </div>
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardStatement()}
        </React.Fragment>
    );
};

//   StatementDetailsForStatementCycle --
const StatementDetailForStatementCycle = ({statementDetailsForStatementCycle, flag}) => {
    const showCreditCardStatement = ()=>{
        return [statementDetailsForStatementCycle].map((item,i)=>{
            return(
                <StatementDetail key={i}>
               <div> Total Amount Due:
                            </div>
                            <div className="value">
                                Rs. {item.totalAmountDue}
                            </div>
                            <LineDivider />  
                            <div>
                                Payment Due Date:
                            </div>
                            <div className="value">
                                {item.paymentDueDate}
                            </div>
                            <LineDivider />
                            <div>
                                Minimum Amount Due:
                            </div>
                            <div className="value">
                                Rs. {item.minimumAmountDue}
                            </div>
                            <LineDivider />
                            <div>
                                Available Credit Limit:
                            </div>
                            <div className="value">
                                Rs. {item.availableCreditLimit}
                            </div>
                            <LineDivider />
                            <div>
                                Available Cash Limit:
                            </div>
                            <div className="value">
                                Rs. {item.availableCashLimit}
                            </div>
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardStatement()}
        </React.Fragment>
    );
};
//   StatementDetailsForOutstanding
const StatementDetailForOutstanding = ({statementDetailsForOutstanding, flag}) => {
    const showCreditCardStatement = ()=>{
        return [statementDetailsForOutstanding].map((item,i)=>{
            return(
                <StatementDetail key={i}>

                    <div>
                        Statement Date:
                    </div>
                    <div className="value">
                        {item.lastStatementDate}
                    </div>
                    <LineDivider />
                    <div>
                        Payment Due Date:
                    </div>
                    <div className="value">
                        {item.paymentDueDate}
                    </div>
                    <LineDivider />
                    <div>
                        Total Amount Due:
                    </div>
                    <div className="value"
                    >
                       Rs. {item.totalAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Minimum Amount Due:
                    </div>
                    <div className="value">
                        Rs. {item.minimumAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Amount:
                    </div>
                    <div className="value">
                        Rs. {item.lastPaymentAmount}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Date:
                    </div>
                    <div className={`value`}>
                        {item.lastPaymentDate}
                    </div>
                    <LineDivider />
                    <div>
                        Available Credit Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCreditLimit}
                    </div>
                    <LineDivider />
                    <div>
                        Available Cash Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCashLimit}
                    </div>
               
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardStatement()}
        </React.Fragment>
    );
};
//   StatementDetailsForMinAmoutDue --
const StatementDetailForMinAmoutDue = ({statementDetailsForMinAmoutDue, flag}) => {
    const showCreditCardStatement = ()=>{
        return [statementDetailsForMinAmoutDue].map((item,i)=>{
            return(
                <StatementDetail key={i}>
                    <div>
                        Statement Date:
                    </div>
                    <div className="value">
                        {item.lastStatementDate}
                    </div>
                    <LineDivider />
                    <div>
                        Payment Due Date:
                    </div>
                    <div className="value">
                        {item.paymentDueDate}
                    </div>
                    <LineDivider />
                    <div>
                        Total Amount Due:
                    </div>
                    <div className="value"
                    >
                       Rs. {item.totalAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Minimum Amount Due:
                    </div>
                    <div className="value">
                        Rs. {item.minimumAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Amount:
                    </div>
                    <div className="value">
                        Rs. {item.lastPaymentAmount}
                    </div>
                    <LineDivider />
                    <div>
                        Last Payment Date:
                    </div>
                    <div className={`value`}>
                        {item.lastPaymentDate}
                    </div>
                    <LineDivider />
                    <div>
                        Available Credit Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCreditLimit}
                    </div>
                    <LineDivider />
                    <div>
                        Available Cash Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCashLimit}
                    </div>
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardStatement()}
        </React.Fragment>
    );
};

//   StatementDetailsForPaymentDetails
const StatementDetailForPaymentDetails = ({statementDetailsForPaymentDetails, flag}) => {
    const showCreditCardStatement = ()=>{
        return [statementDetailsForPaymentDetails].map((item,i)=>{
            return(
                <StatementDetail key={i}>
                    <div>
                        Payment Due Date:
                    </div>
                    <div className="value">
                        {item.paymentDueDate}
                    </div>
                    <LineDivider />
                    <div>
                        Total Amount Due:
                    </div>
                    <div className="value"
                    >
                       Rs. {item.totalAmountDue}
                    </div>
                    <LineDivider />
                    <div>
                        Minimum Amount Due:
                    </div>
                    <div className="value">
                        Rs. {item.minimumAmountDue}
                    </div>
                    <LineDivider />
                   
                    <div>
                        Available Credit Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCreditLimit}
                    </div>
                    <LineDivider />
                    <div>
                        Available Cash Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCashLimit}
                    </div>
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardStatement()}
        </React.Fragment>
    );
};

const LastPaymentStatement = ({lastPaymentDetails}) => {
    const showLastPaymentStatement = ()=>{
        return lastPaymentDetails.map((item,i)=>{
            return(
                <StatementDetail key={i}>
                    <div className='bill-amount'>  {/*className='bill-amount'*/}
                        Payment Amount:  <div className="value">Rs. {item.billingAmount}</div> {/*item.lastPaymentAmount*/}
                    </div>
                    <LineDivider />
                    <div className='transaction-date'> {/*className='transaction-date'*/}
                        Payment Date: <div className={`value`}>{item.transactionDate}</div> {/*item.lastPaymentDate*/}
                    </div>
                    <LineDivider />    {/* only on dev,preprod*/}
                    <div className='payment-mode'>
                        Payment Mode: <div className={`value`}>{item.paymentMode}</div>
                    </div>
                    <LineDivider />
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showLastPaymentStatement()}
        </React.Fragment>
    );
};


//Total Credit Limit: TotalCreditLimit
//Available Credit Limit: AvailableCreditLimit
//Total Cash Limit: TotalCashLimit

const CreditCardGetTotalCreditLimit = ({data}) => { //GetTotalCreditLimit
    const showCreditCardGetTotalCreditLimit = ()=>{
        return [data].map((item,i)=>{
            return(
                <StatementDetail key={i}>
                     <div>
                        Total Credit Limit:
                    </div>
                    <div className={`value`}>
                        Rs. {item.totalCreditLimit}
                    </div>
                  
                    <LineDivider />
                    <div>
                        Available Credit Limit:
                    </div>
                    <div className={`value`}>
                        Rs. {item.availableCreditLimit}
                    </div>
                    <LineDivider />
                    <div>
                        Total Cash Limit:
                    </div>
                    <div className="value">
                        Rs. {item.totalCashLimit}
                    </div>
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardGetTotalCreditLimit()}
        </React.Fragment>
    );
};


const CreditCardGetAvailableCreditLimit = ({data}) => { 
    const showCreditCardGetAvailableCreditLimit = ()=>{
        return [data].map((item,i)=>{
            return(
                <StatementDetail key={i}>
                  <div>
                     Total Cash Limit:
                    </div>
                    <div className={`value`}>
                        Rs. {item.totalCashLimit}
                    </div>
                     <LineDivider />
                    <div>
                        Available Cash Limit:
                    </div>
                    <div className="value">
                        Rs. {item.availableCashLimit}
                    </div>
                   
                </StatementDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showCreditCardGetAvailableCreditLimit()}
        </React.Fragment>
    );
};

//GetAvailableCreditLimit

const StatementDetail = styled.div`
    display:flex;
    flex-direction : column;
    margin-top : 15px;
   
    & .bill-amount, & .transaction-date, & .payment-mode {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        .value {
            margin-top: 0px !important;
        }
    }
    & .value{
        margin-top : 3px;
        font-weight: 500;
        color: #2c387a;
        &.positive{
            color : #31ba74;
        }
        &.negative{
            color : #d82424;
        }
    }
`

export {
    LastPaymentStatement,
    CreditCardGetTotalCreditLimit,
    CreditCardGetAvailableCreditLimit,
    StatementDetailForLastPayment,
    StatementDetailForStatementCycle,
    StatementDetailForOutstanding,
    StatementDetailForMinAmoutDue,
    StatementDetailForPaymentDetails
};

export default CreditCardStatement;